import { useCallback, useEffect, useState } from "react";
import { chatWebSocketManager } from "../websocket";
import type { ChatConnectionStatus } from "../websocket";

export function useWebSocketConnection(chatId: string | undefined) {
  const [connectionStatus, setConnectionStatus] =
    useState<ChatConnectionStatus>("disconnected");
  const [error, setError] = useState<Error | null>(null);

  const connection = chatId ? chatWebSocketManager.getConnection(chatId) : null;

  const handleStatusChange = useCallback((status: ChatConnectionStatus) => {
    setConnectionStatus(status);
  }, []);

  useEffect(() => {
    if (!connection) {
      return;
    }

    connection.addStatusHandler(handleStatusChange);
    connection.addErrorHandler(setError);

    return () => {
      connection.removeStatusHandler(handleStatusChange);
      connection.removeErrorHandler(setError);
    };
  }, [connection, handleStatusChange]);

  const connect = useCallback(async () => {
    if (!connection) {
      return;
    }

    try {
      await connection.connect();
    } catch (error) {
      setError(error as Error);
    }
  }, [connection]);

  return {
    connection,
    status: connectionStatus,
    error,
    setError,
    connect,
  };
}
